export default __webpack_public_path__ + "static/media/crisalisaquino.b8986ad7.jpg";